import React, { useMemo } from 'react'
import { generateUUID } from '../../utils/id'

type Props = React.SVGProps<SVGSVGElement> & {
  monochrome?: boolean
}

const colours = {
  top: {
    colour: {
      light: '#162C80',
      dark: '#3266FF',
    },
    monochrome: {
      light: '#646464',
      dark: '#474747',
    },
  },
  middle: {
    colour: '#52BEFF',
    monochrome: '#7a7a7a',
  },
  bottom: {
    colour: {
      light: '#ABE6FF',
      dark: '#57CCFF',
    },
    monochrome: {
      light: '#D6D6D6',
      dark: '#8A8A8A',
    },
  },
}

export const EtBrandSygnet = ({
  monochrome = false,
  width = 40,
  height = 32,
  ...rest
}: Props) => {
  const id = useMemo(() => generateUUID(), [])
  const topGradientId = `paint0_linear_${id}`
  const bottomGradientId = `paint1_linear_${id}`

  const topColours = monochrome ? colours.top.monochrome : colours.top.colour
  const middleColour = monochrome ? colours.middle.monochrome : colours.middle.colour
  const bottomColours = monochrome ? colours.bottom.monochrome : colours.bottom.colour

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {/* top bar */}
      <path
        d="M16.0492 0H36.3618C37.2782 0 38.3247 1.60283 37.1873 2.89482L26.9513 14.3503L14.7822 0.232563C15.2411 0 16.0492 0 16.0492 0Z"
        fill={`url(#${topGradientId})`}
      />

      {/* bottom bar */}
      <path
        d="M1.38139 12.5509L7.26378 6.95801L20.2797 22.0582L20.2789 22.059L26.0264 28.7268H12.7115L1.23907 15.4173C0.514546 14.5768 0.577163 13.3155 1.38139 12.5509Z"
        fill={`url(#${bottomGradientId})`}
      />

      {/* middle bar */}
      <path
        d="M7.26367 6.95819L13.5759 0.956623C13.9493 0.601646 14.3952 0.37536 14.7826 0.232422L27.5981 15.1L37.1877 25.8321C38.3251 27.1241 37.2787 28.727 36.3623 28.727H26.0262L20.2788 22.0591L20.2796 22.0584L7.26367 6.95819Z"
        fill={middleColour}
      />

      <defs>
        <linearGradient
          id={topGradientId}
          x1={14.7822}
          y1={7.17515}
          x2={37.6844}
          y2={7.17515}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={topColours.light} />
          <stop offset={1} stopColor={topColours.dark} />
        </linearGradient>

        <linearGradient
          id={bottomGradientId}
          x1={0.049161}
          y1={10.5803}
          x2={19.3572}
          y2={24.6888}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.042133} stopColor={bottomColours.light} />
          <stop offset={0.648703} stopColor={bottomColours.dark} />
        </linearGradient>
      </defs>
    </svg>
  )
}
